import { computed } from 'vue';
import { useUserStore } from '@/store/userStore';
import { useRoleCheck } from '@/composables/useRoleCheck';

export function useModules() {
  const userStore = useUserStore();
  const { isSuperAdmin } = useRoleCheck();

  const activeModuleSubscriptions = computed(() => {
    const userData = userStore.userData;
    if (!userData) return [];

    if (userData.license_subscriptions?.length) {
      return userData.license_subscriptions.filter(
        (sub) => sub.license?.type === 'module' && sub.status === 'active'
      );
    }

    if (userData.active_modules?.length) {
      return userData.active_modules;
    }

    return [];
  });

  const hasModule = (moduleName) => {
    if (isSuperAdmin.value) return true;

    const name = moduleName.toLowerCase();
    return activeModuleSubscriptions.value.some((sub) => {
      const subName = sub.license?.name || sub.name || '';
      return subName.toLowerCase().includes(name);
    });
  };

  const hasSlimWerken = computed(() => hasModule('slim werken'));
  const hasSlimInnen = computed(() => hasModule('slim innen'));

  return {
    activeModuleSubscriptions,
    hasModule,
    hasSlimWerken,
    hasSlimInnen,
  };
}
